import SectionReveal from './SectionReveal';
import AnimatedCounter from './AnimatedCounter';

const ABOUT_IMG = "https://images.unsplash.com/photo-1762381157076-4872b31961e0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwzfHx3aW5kJTIwdHVyYmluZSUyMHNvbGFyJTIwcGFuZWxzfGVufDB8fHx8MTc3NDc5NzI3N3ww&ixlib=rb-4.1.0&q=85";

// Numeric animation data (language-independent)
const COUNTER_DATA = [
  { target: 3,    start: 0,    prefix: '',  suffix: '+ GW', duration: 1800 },
  { target: 550,  start: 0,    prefix: '€', suffix: 'M',    duration: 1600 },
  { target: 2030, start: 2020, prefix: '',  suffix: '',     duration: 2000 },
];

export default function AboutSection({ text }) {
  const statLabels = [text.stat1.label, text.stat2.label, text.stat4.label];

  return (
    <section id="about" className="py-24 sm:py-32 bg-[#050505]">
      <div className="container mx-auto px-6 lg:px-12 max-w-7xl">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <SectionReveal>
              <p className="text-xs tracking-[0.28em] uppercase text-[#D4A017] mb-4 font-medium">{text.label}</p>
              <h2 className="text-3xl sm:text-4xl lg:text-5xl font-medium text-white mb-6 leading-tight" style={{ fontFamily: "'Outfit', sans-serif" }}>
                {text.title}
              </h2>
              <p className="text-base text-white/60 leading-relaxed mb-12">{text.body}</p>
            </SectionReveal>

            <SectionReveal delay={100}>
              <div className="grid grid-cols-2 gap-4">
                {COUNTER_DATA.map((c, i) => (
                  <AnimatedCounter
                    key={c.target}
                    target={c.target}
                    start={c.start}
                    prefix={c.prefix}
                    suffix={c.suffix}
                    duration={c.duration}
                    label={statLabels[i]}
                  />
                ))}
              </div>
            </SectionReveal>
          </div>

          <SectionReveal delay={200}>
            <div className="relative h-[500px] overflow-hidden">
              <img
                src={ABOUT_IMG}
                alt="Renewable Energy Infrastructure"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-gradient-to-r from-[#D4A017]/60 to-transparent" />
            </div>
          </SectionReveal>
        </div>
      </div>
    </section>
  );
}
